var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8 0.235566C12.0783 0.536959 12.0645 1.01157 11.7692 1.29563L4.0012 8.76859C3.67179 9.08549 3.15469 9.07572 2.83699 8.7466L0.211354 6.02661C-0.0734292 5.7316 -0.0699844 5.25679 0.219048 4.96611C0.508081 4.67543 0.97325 4.67895 1.25803 4.97397L3.44658 7.24117L10.7614 0.204188C11.0567 -0.0798757 11.5217 -0.0658273 11.8 0.235566Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmark);
export default __webpack_public_path__ + "static/media/checkmark.44b6c7d43e9dd8c326f0dc66f6a40650.svg";
export { ForwardRef as ReactComponent };